import { render, staticRenderFns } from "./FormColorpicker.vue?vue&type=template&id=4aeeef12&"
import script from "./FormColorpicker.vue?vue&type=script&lang=js&"
export * from "./FormColorpicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports